import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from '../static/styles/Home.module.css';
import weeklyTournamentStyles from '../static/styles/WeeklyTournaments.module.css';
import { fetchWeeklyTournaments, fetchEslTournaments } from '../api/tournaments';
import { fetchDailyGames, listEslGames } from '../api/games';
import { fetchHighlights, fetchGameHighlights } from '../api/highlights';
import { getRewardsList } from '../api/rewards';

import gamezAcad1 from '../static/img/LearnWin/gamezAcad_1.avif';
import gamezAcad2 from '../static/img/LearnWin/gamezAcad_2.avif';
import gamezAcad3 from '../static/img/LearnWin/gamezAcad_3.avif';

import pubgHighlight from '../static/img/Highlights/pubgHighlight_Portrait.avif';
import freeFireHighlight from '../static/img/Highlights/freeFireHighlight_Portrait.avif';
import codHighlight from '../static/img/Highlights/codHighlight_Portrait.avif';


import arrowBackIcon from '../static/img/Home/arrowLeftIcon.svg';
import arrowForwardIcon from '../static/img/Home/arrowRightIcon.svg';
import calendarIcon from '../static/img/Home/calendarIcon.svg';

import pubgImageDummy from '../static/img/Home/pubgDummy.avif';
import pubgWeekly from '../static/img/Home/pubgWeekly.png'

import pubgIcon from '../static/img/DailyGamingTasks/iconPubgDailyTasks.png';
import freeFireIcon from '../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif';

import pubgBg from '../static/img/WeeklyTournaments/imagePubgWeeklyTournament.avif';
import freefireBg from '../static/img/WeeklyTournaments/imageFreeFireWeeklyTournament.avif';

import pubgImage from '../static/img/DailyGamingTasks/imagePubgGaming.avif';
import apexImage from '../static/img/DailyGamingTasks/imageApexLegendsGaming.avif';
import codImage from '../static/img/DailyGamingTasks/imageCODGaming.avif';
import minecraftImage from '../static/img/DailyGamingTasks/imageMinecraftGaming.avif';
import clashOfClansImage from '../static/img/DailyGamingTasks/imageCOCGaming.avif';
import clashRoyaleImage from '../static/img/DailyGamingTasks/imageCRGaming.avif';
import fortniteImage from '../static/img/DailyGamingTasks/imageFortniteGaming.avif';
import amongUsImage from '../static/img/DailyGamingTasks/imageAmongUsGaming.avif';
import subwaySurfersImage from '../static/img/DailyGamingTasks/imageSubSurfGaming.avif';
import valorantImage from '../static/img/DailyGamingTasks/imageValorantGaming.avif';
import freeFireImage from '../static/img/DailyGamingTasks/imageFreeFireGaming.avif';
import robloxImage from '../static/img/DailyGamingTasks/imageRobloxGaming.avif';
import fifaImage from '../static/img/DailyGamingTasks/imageFifaGaming.avif';
import eightBallPoolImage from '../static/img/DailyGamingTasks/image8BallPool.avif';

import playstation5Img from '../static/img/Rewards/Playstation5_Portrait.png';
import asusRogStrixGoImg from '../static/img/Rewards/AsusROGStrixGoUSBCGamingHeadset.avif';
import asusRogDeltaSCoreImg from '../static/img/Rewards/AsusROGDeltaSCoreGamingHeadphone.avif';
import edifierG1Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG2.avif';
import edifierG2Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG2.avif';
import asusTufKeyboardImg from '../static/img/Rewards/bloody_keyboard.avif';
import bloodyB760Img from '../static/img/Rewards/bloody_keyboard.avif';
import bloodyB865NImg from '../static/img/Rewards/BloodyMechanicalGamingKeyboardB865N.avif';
import asusGladiusImg from '../static/img/Rewards/AsusROGGladiusIIIP514GamingMouse.avif';
import asusKerisImg from '../static/img/Rewards/AsusROGKerisP509GamingMouse.avif';
import pubgImg from '../static/img/Rewards/pubgReward.jpg';
import fortniteImg from '../static/img/Rewards/fortniteReward.avif';
import minecraftImg from '../static/img/Rewards/mirecraft_Reward.jpg';
import aimTrainCover from '../static/img/MadeByESL/aim_train_home.avif';
import aimTrainCoverSmall from '../static/img/MadeByESL/coverAimTrain.avif';
import aimTrainBattle from '../static/img/MadeByESL/aimTrainBattle.avif'
import cannonClashCover from '../static/img/MadeByESL/coverCannonClash.jpeg';
import cannonClashCoverLarge from '../static/img/MadeByESL/cannon_clash_home.avif';
import puzzleManiaCover from '../static/img/MadeByESL/coverPuzzleMania.avif';
import puzzleManiaCoverLarge from '../static/img/MadeByESL/puzzle_mania_home.avif';
import spaceFootballCover from '../static/img/MadeByESL/coverSpaceFootball.png.avif';
import CannonClashInstructions from '../components/CannonClashInstructions';

import playIcon from '../static/img/Highlights/iconPlayArrow.svg';

import weeklyTournamentsImg from '../static/img/Home/weeklyTournsHome.avif';
import codGamingImg from '../static/img/Home/dailyGamingHome.avif';
import playstation5BannerImg from '../static/img/Home/rewardsHome.avif';

import weeklyTournamentsImgMobile from '../static/img/Home/weeklyTournsHome_Portrait.avif';
import codGamingImgMobile from '../static/img/Home/dailyGamingHome_Portrait.avif';
import playstation5BannerImgMobile from '../static/img/Home/rewardsHome_Portrait.avif';


SwiperCore.use([Autoplay, Pagination]);

const getDailyTaskImage = (gameName, isMobile = false) => {
  // Check if screen width is between 500px and 767px for larger Made by ESL images
  const isMediumScreen = window.innerWidth >= 500 && window.innerWidth <= 767;
  
  switch (gameName.toLowerCase()) {
    case 'clash royale': return clashRoyaleImage;
    case 'call of duty': return codImage;
    case 'pubg mobile': return pubgImage;
    case 'minecraft': return minecraftImage;
    case 'freefire': return freeFireImage;
    case 'fortnite': return fortniteImage;
    case 'apex legends': return apexImage;
    case 'roblox': return robloxImage;
    case 'among us': return amongUsImage;
    case 'fifa mobile': return fifaImage;
    case 'valorant': return valorantImage;
    case 'subway surfers': return subwaySurfersImage;
    case 'clash of clans': return clashOfClansImage;
    case '8 ball pool': return eightBallPoolImage;
    case 'aim train': return isMediumScreen ? aimTrainCover : aimTrainCoverSmall;
    case 'cannon clash': return isMediumScreen ? cannonClashCoverLarge : cannonClashCover;
    case 'puzzle mania': return isMediumScreen ? puzzleManiaCoverLarge : puzzleManiaCover;
    case 'space football': return spaceFootballCover;
    default:
      return null; // Fallback img..
  }
};

const getGameIcon = (gameName) => {
  switch (gameName.toLowerCase()) {
    case 'pubg mobile': return pubgIcon;
    case 'freefire': return freeFireIcon;
    default: return null;
  }
};

const getGameBackground = (gameName) => {
  switch (gameName.toLowerCase()) {
    case 'pubg mobile': return pubgBg;
    case 'freefire': return freefireBg;
    // Add other games
    default: return null;
  }
};

const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return { date: 'N/A', time: 'N/A' };
  const [datePart, timePart, ampm] = dateTimeString.split(' ');
  return {
    date: datePart,
    time: `${timePart} ${ampm}`
  };
};

function Home() {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [dailyGamesData, setDailyGamesData] = useState([]);
  const [loadingDailyGames, setLoadingDailyGames] = useState(true);
  const [errorDailyGames, setErrorDailyGames] = useState(null);

  const [weeklyTournamentsData, setWeeklyTournamentsData] = useState([]);
  const [eslTournamentsData, setEslTournamentsData] = useState([]);
  const [loadingWeekly, setLoadingWeekly] = useState(true);
  const [errorWeekly, setErrorWeekly] = useState(null);

  const [highlightsData, setHighlightsData] = useState([]);
  const [loadingHighlights, setLoadingHighlights] = useState(true);
  const [errorHighlights, setErrorHighlights] = useState(null);

  const [gameHighlightsData, setGameHighlightsData] = useState([]);
  const [loadingGameHighlights, setLoadingGameHighlights] = useState(true);
  const [errorGameHighlights, setErrorGameHighlights] = useState(null);

  const [eslGames, setEslGames] = useState([]);
  const [loadingEslGames, setLoadingEslGames] = useState(true);
  const [errorEslGames, setErrorEslGames] = useState(null);

  const [rewardsData, setRewardsData] = useState([]);
  const [loadingRewards, setLoadingRewards] = useState(true);
  const [errorRewards, setErrorRewards] = useState(null);

  const [mainSliderBanners, setMainSliderBanners] = useState([]);
  const [showInstructions, setShowInstructions] = useState(false);

  useEffect(() => {
    document.title = "Home | Jazz Esl"
    const loadWeeklyTournaments = async () => {
      try {
        setLoadingWeekly(true);
        setErrorWeekly(null);
        const [weeklyData, eslData] = await Promise.all([
          fetchWeeklyTournaments(),
          fetchEslTournaments()
        ]);
        setWeeklyTournamentsData(weeklyData);
        setEslTournamentsData(eslData);
      } catch (err) {
        setErrorWeekly(err.message || t('failed_load_tours'));
      } finally {
        setLoadingWeekly(false);
      }
    };
    loadWeeklyTournaments();
  }, [t]);

  useEffect(() => {
    const loadRewards = async () => {
      try {
        setLoadingRewards(true);
        setErrorRewards(null);
        const response = await getRewardsList();
        if (response && response.data && Array.isArray(response.data)) {
          //console.log(response.data)
          setRewardsData(response.data);
        } else {
          setRewardsData([]);
        }
      } catch (err) {
        setErrorRewards(err.message || t('failed_load_rews'));
      } finally {
        setLoadingRewards(false);
      }
    };
    loadRewards();
  }, [t]);

  useEffect(() => {
    const loadDailyGames = async () => {
      try {
        setLoadingDailyGames(true);
        setErrorDailyGames(null);
        const data = await fetchDailyGames();
        data.forEach(game => {
          getDailyTaskImage(game.game, isMobile);
        });
        setDailyGamesData(data);
      } catch (err) {
        setErrorDailyGames(err.message || t('failed_load_d_games'));
      } finally {
        setLoadingDailyGames(false);
      }
    };
    loadDailyGames();
  }, [t]);

  useEffect(() => {
    const loadHighlights = async () => {
      try {
        setLoadingHighlights(true);
        setErrorHighlights(null);
        const data = await fetchHighlights();
        setHighlightsData(data);
      } catch (err) {
        setErrorHighlights(err.message || t('failed_load_highs'));
      } finally {
        setLoadingHighlights(false);
      }
    };
    loadHighlights();
  }, [t]);

  useEffect(() => {
    const loadGameHighlights = async () => {
      try {
        setLoadingGameHighlights(true);
        setErrorGameHighlights(null);
        const data = await fetchGameHighlights();
        setGameHighlightsData(data);
      } catch (err) {
        setErrorGameHighlights(err.message || t('failed_load_game_highs'));
      } finally {
        setLoadingGameHighlights(false);
      }
    };
    loadGameHighlights();
  }, [t]);

  // ESL games
  useEffect(() => {
    const loadEslGames = async () => {
      try {
        setLoadingEslGames(true);
        setErrorEslGames(null);
        const eslGamesResp = await listEslGames();
        let eslGamesArr = [];
        if (
          eslGamesResp &&
          eslGamesResp.success &&
          eslGamesResp.data &&
          Array.isArray(eslGamesResp.data.eslgames)
        ) {
          eslGamesArr = eslGamesResp.data.eslgames.map(eslGame => ({
            ...eslGame,
            game: eslGame.game_name
          }));
        }

        setEslGames(eslGamesArr);
      } catch (err) {
        setErrorEslGames(err.message || t('failed_load_esl'));
      } finally {
        setLoadingEslGames(false);
      }
    };
    loadEslGames();
  }, [t]);

  useEffect(() => {
    const baseBanners = [
      {
        id: 1,
        image: isMobile ? weeklyTournamentsImgMobile : weeklyTournamentsImg,
        title: t('browse_weekly'),
        buttonText: t('browse_weekly'),
        navigateTo: '/tournaments',
      },
      {
        id: 2,
        image: isMobile ? codGamingImgMobile : codGamingImg,
        title: t('browse_gaming'),
        buttonText: t('browse_gaming'),
        navigateTo: '/daily-gaming-tasks',
      },
      {
        id: 3,
        image: isMobile ? playstation5BannerImgMobile : playstation5BannerImg,
        title: t('rews_msg'),
        buttonText: t('rews_msg'),
        navigateTo: '/rewards',
      },
    ];

    // ESL games in top banner
    // const eslGameBanners = eslGames.map((game, idx) => ({
    //   id: `esl-${game.game_unique_id || idx}`,
    //   image: getDailyTaskImage(game.game) || pubgImageDummy,
    //   title: game.game,
    //   buttonText: `Play ${game.game}`,
    //   onClick: () => handleDailyGameClick(game.gameId || game.game_unique_id),
    //   isEsl: true,
    // }));

    setMainSliderBanners([...baseBanners]);
  }, [isMobile, eslGames, t]);

  const breakpoints4Slides = {
    0: { // Smol Mobile
      slidesPerView: 1,
      spaceBetween: 15
    },
    300: { // Mobile
      slidesPerView: 1.5,
      spaceBetween: 15
    },
    400: { // Whatever
      slidesPerView: 2.2,
      spaceBetween: 15
    },
    768: { // Tablet
      slidesPerView: 3,
      spaceBetween: 20
    },
    1024: { // Desktop
      slidesPerView: 4,
      spaceBetween: 20
    }
  };

  const breakpoints3Slides = {
    0: { // Mobile
      slidesPerView: 1.1,
      spaceBetween: 15
    },
    768: { // Tablet
      slidesPerView: 1.6,
      spaceBetween: 20
    },
    1024: { // Desktop
      slidesPerView: 2.3,
      spaceBetween: 20
    }
  }

  const eslGameBreakpoints = {
    0: {
      slidesPerView: 1,
      spaceBetween: 15
    },
    768: { // Tablet
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: { // Desktop
      slidesPerView: 3,
      spaceBetween: 20
    }
  };

  const handleDailyGameClick = (gameId, gameName) => {
    if (!gameId) {
      return;
    }
    if (gameName && gameName.toLowerCase() === 'cannon clash') {
      navigate('/tournaments');
    } else {
      navigate(`/game-challenges?gameId=${encodeURIComponent(gameId)}`);
    }
  };

  const handleInstructionsClose = () => {
    setShowInstructions(false);
  };

  const handleShowInstructions = (gameName) => {
    const isCannonClash = gameName && gameName.toLowerCase().includes('cannon');
    if (isCannonClash) {
      setShowInstructions(true);
    }
  };

  const getGameHighlightImage = (gameName) => {
    switch (gameName.toLowerCase()) {
      case 'pubg':
      case 'pubg mobile':
        return pubgHighlight;
      case 'freefire':
        return freeFireHighlight;
      case 'call of duty':
        return codHighlight;
      default:
        return pubgImageDummy; // Fallback img..
    }
  };

  return (
    <>
      {/* MAIN SLIDER */}
      <div className={styles.container}>
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          autoplay={{ delay: 4000 }}
          loop={mainSliderBanners.length > 1}
          slidesPerView={1}
          pagination={{
            el: '.tournament-pagination',
            clickable: true,
          }}
          className="tournament-swiper"
        >
          {mainSliderBanners.map((banner) => (
            <SwiperSlide key={banner.id}>
              <div className={styles.slideContainer}>
                <div
                  className={styles.slideImage}
                  style={{ backgroundImage: `url(${banner.image})` }}
                />
                <div className={styles.overlay} />
                <div className={styles.content}>
                  {/* <h2 className={styles.title}>{banner.title}</h2> */}
                  <button
                    className={styles.joinButton}
                    onClick={
                      banner.isEsl
                        ? banner.onClick
                        : () => navigate(banner.navigateTo)
                    }
                  >
                    {banner.buttonText}
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="tournament-pagination"></div>

        <button
          onClick={() => swiperRef.current?.slidePrev()}
          className={`${styles.navButton} ${styles.prevButton}`}
        >
          <img src={arrowBackIcon} alt="Previous" className={styles.navIcon} />
        </button>

        <button
          onClick={() => swiperRef.current?.slideNext()}
          className={`${styles.navButton} ${styles.nextButton}`}
        >
          <img src={arrowForwardIcon} alt="Next" className={styles.navIcon} />
        </button>
      </div>

      <div className={styles.weeklyTasksSection}>
        <div className={styles.dailyTasksHeader}>
          <div className={styles.dailyTasksTitleContainer}>
            <h3 className={styles.dailyTasksTitle}>{t('made_by_esl')}</h3>
            <p className={styles.dailyTasksSubtitle}>{t('esl_origs_msg')}</p>
          </div>
        </div>
        {loadingEslGames && <div className={styles.loading}>{t('loading')}</div>}
        {errorEslGames && <div className={styles.error}>{errorEslGames}</div>}
        {!loadingEslGames && !errorEslGames && eslGames.length > 0 && (
          <Swiper
            breakpoints={eslGameBreakpoints}
            className={styles.weeklyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={eslGames.length > 1}
          >
            {eslGames
              .filter((game) => game.game_status === 1)
              .map((game) => {
                const gameImage = getDailyTaskImage(game.game, isMobile) || pubgImageDummy;
                return (
                  <SwiperSlide key={game.game_unique_id || game.id}>
                    <div
                      onClick={() => handleDailyGameClick(game.gameId || game.game_unique_id, game.game)}
                      className={styles.clickableTaskCard}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => e.key === 'Enter' && handleDailyGameClick(game.gameId || game.game_unique_id, game.game)}
                    >
                      <div className={styles.taskCard}>
                        <div
                          className={styles.madeByESL}
                          style={{ backgroundImage: `url(${gameImage})` }}
                        >
                          {game.game && game.game.toLowerCase().includes('cannon') && (
                            <button 
                              className={weeklyTournamentStyles.infoButton}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleShowInstructions(game.game);
                              }}
                              title={t('view_game_inst')}
                            >
                              <span className={weeklyTournamentStyles.infoIcon}>?</span>
                              <span className={weeklyTournamentStyles.infoText}>{t('how_play')}</span>
                            </button>
                          )}
                        </div>
                        <p className={styles.taskTitle}>{game.game}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        )}
      </div>

      {/* DAILY TASKS */}
      <div className={styles.dailyTasksSection}>
        <div className={styles.dailyTasksHeader}>
          <div className={styles.dailyTasksTitleContainer}>
            <h3 className={styles.dailyTasksTitle}>{t('gaming_tasks')}</h3>
            <p className={styles.dailyTasksSubtitle}>{t('daily_t_msg')}</p>
          </div>
          <button className={styles.viewAllButton} onClick={() => navigate('/daily-gaming-tasks')}>
            {t('view_all')} <span>›</span>
          </button>
        </div>

        {loadingDailyGames && <div className={styles.loading}>{t('loading')}</div>}
        {errorDailyGames && <div className={styles.error}>{errorDailyGames}</div>}
        {!loadingDailyGames && !errorDailyGames && (
          <Swiper
            breakpoints={breakpoints4Slides}
            className={styles.dailyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={dailyGamesData.length > 4}
          >
            {dailyGamesData.map((game) => {
              const gameImage = getDailyTaskImage(game.game, isMobile) || pubgImageDummy;
              return (
                <SwiperSlide key={game.id}>
                  <div
                    onClick={() => handleDailyGameClick(game.gameId)}
                    className={styles.clickableTaskCard}
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) => e.key === 'Enter' && handleDailyGameClick(game.gameId)}
                  >
                    <div className={styles.taskCard}>
                      <div
                        className={styles.taskImage}
                        style={{ backgroundImage: `url(${gameImage})` }}
                      >
                        {/* <span className={styles.notificationBadge}>{task.notificationCount}</span> */}
                      </div>
                      <p className={styles.taskTitle}>{game.game}</p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      {/* WEEKLY TOURNAMENTS */}
      <div className={styles.weeklyTasksSection}>
        <div className={styles.dailyTasksHeader}>
          <div className={styles.dailyTasksTitleContainer}>
            <h3 className={styles.dailyTasksTitle}>{t('tournaments')}</h3>
            <p className={styles.dailyTasksSubtitle}>{t('win_big_creds')}</p>
          </div>
          <button className={styles.viewAllButton} onClick={() => navigate('/tournaments')}>
            {t('view_all')} <span>›</span>
          </button>
        </div>

        {loadingWeekly && <div className={styles.loading}>{t('loading')}</div>}
        {errorWeekly && <div className={styles.error}>{errorWeekly}</div>}
        {!loadingWeekly && !errorWeekly && (
          <Swiper
            breakpoints={breakpoints3Slides}
            className={styles.weeklyTasksSwiper}
            autoplay={{ delay: 3000 }}
            loop={weeklyTournamentsData.length + eslTournamentsData.length > 3}
          >
            {eslTournamentsData
              .filter(tournament => tournament.status !== 4) // Filter out ended tournaments
              .map((tournament) => {
                const isCannonClash = tournament.tourn_name && tournament.tourn_name.toLowerCase().includes('cannon');
                const isAimTrain = tournament.tourn_name && tournament.tourn_name.toLowerCase().includes('aim train');
                return (
                  <SwiperSlide key={`esl-${tournament.Id || tournament.id}`}>
                    <div
                      className={styles.weeklyTaskCard}
                      onClick={() => navigate('/tournaments')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div
                        className={styles.weeklyTaskImage}
                        style={{ 
                          backgroundImage: isCannonClash 
                            ? `url(${cannonClashCover})`
                            : isAimTrain ? `url(${aimTrainBattle})`
                            : tournament.thumbnail 
                              ? `url(${tournament.thumbnail})` 
                              : 'none' 
                        }}
                      >
                        {isCannonClash && (
                          <button 
                            className={weeklyTournamentStyles.infoButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleShowInstructions(tournament.tourn_name);
                            }}
                            title={t('view_tour_inst')}
                          >
                            <span className={weeklyTournamentStyles.infoIcon}>?</span>
                            <span className={weeklyTournamentStyles.infoText}>{t('how_play')}</span>
                          </button>
                        )}
                        <div className={styles.weeklyTaskDateContainer}>
                          <img src={calendarIcon} alt="calendar" className={styles.dateIcon} />
                          <span className={styles.weeklyTaskDate}>{formatDateTime(tournament.time).date}</span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}

            {/* Weekly Tournaments */}
            {weeklyTournamentsData.map((tournament) => {
              const { date } = formatDateTime(tournament.time);
              const gameBgSrc = getGameBackground(tournament.tourn_name);
              const gameIconSrc = getGameIcon(tournament.tourn_name);

              return (
                <SwiperSlide key={`weekly-${tournament.id}`}>
                  <div
                    className={styles.weeklyTaskCard}
                    onClick={() => navigate(`/join-tournament?tournamentId=${tournament.tourn_id}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div
                      className={styles.weeklyTaskImage}
                      style={{ backgroundImage: gameBgSrc ? `url(${gameBgSrc})` : 'none' }}
                    >
                      {gameIconSrc && <img src={gameIconSrc} alt={tournament.tourn_name} className={styles.weeklyTaskGameIcon} />}
                      <div className={styles.weeklyTaskDateContainer}>
                        <img src={calendarIcon} alt="calendar" className={styles.dateIcon} />
                        <span className={styles.weeklyTaskDate}>{date}</span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      <div className={styles.weeklyTasksSection}>
        <div className={styles.dailyTasksHeader}>
          <div className={styles.dailyTasksTitleContainer}>
            <h3 className={styles.dailyTasksTitle}>{t('learn_n_win')}</h3>
            <p className={styles.dailyTasksSubtitle}>{t('test_mettle')}</p>
          </div>
          <button className={styles.viewAllButton} onClick={() => navigate('/learn-win')}>
            {t('view_all')} <span>›</span>
          </button>
        </div>

        <Swiper
          breakpoints={breakpoints3Slides}
          className={styles.weeklyTasksSwiper}
          autoplay={{ delay: 3000 }}
          loop={true}
        >
          {[gamezAcad1, gamezAcad2, gamezAcad3].map((image, index) => (
            <SwiperSlide key={index}>
              <div
                className={styles.weeklyTaskCard}
                onClick={() => window.open('https://gamezacademy.pk/', '_blank')}
                style={{ cursor: 'pointer' }}
              >
                <div
                  className={styles.weeklyTaskImage}
                  style={{ backgroundImage: `url(${image})` }}
                >
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Rewards */}
      <div className={styles.dailyTasksSection}>
        <div className={styles.dailyTasksHeader}>
          <div className={styles.dailyTasksTitleContainer}>
            <h3 className={styles.dailyTasksTitle}>{t('rewards')}</h3>
            <p className={styles.dailyTasksSubtitle}>{t('rews_msg_1')}</p>
          </div>
          <button className={styles.viewAllButton} onClick={() => navigate('/rewards')}>
            {t('view_all')} <span>›</span>
          </button>
        </div>

        {loadingRewards && <div className={styles.loading}>{t('loading')}</div>}
        {errorRewards && <div className={styles.error}>{errorRewards}</div>}
        {!loadingRewards && !errorRewards && (
          <Swiper
            breakpoints={breakpoints4Slides}
            className={styles.dailyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={rewardsData.length > 4}
          >
            {rewardsData.map((reward) => {
              const getRewardImage = (rewardId) => {
                switch (rewardId) {
                  case 1: return playstation5Img; // Playstation 5
            case 2: return asusRogDeltaSCoreImg; // Asus ROG Gaming Headphone
            case 3: return edifierG1Img; // Edifier USB Gaming Headset
            case 4: return asusTufKeyboardImg; // Asus Gaming Keyboard
            case 5: return bloodyB760Img; // Bloody Mechanical Gaming Keyboard
            case 6: return asusGladiusImg; // Asus ROG Gaming Mouse
            case 7: case 8: case 9: case 10: return pubgImg; // PUBG Mobile UC
            case 11: case 12: case 13: return fortniteImg; // Fortnite V-Bucks
            case 14: case 15: return minecraftImg; // Minecraft Minecoins
            default: return '';
                }
              };

              const rewardImage = getRewardImage(reward.id);

              return (
                <SwiperSlide key={reward.id || reward.name}>
                  <div className={styles.taskCard}>
                    <div
                      className={styles.taskImage}
                      style={{ backgroundImage: rewardImage ? `url(${rewardImage})` : 'none' }}
                    >
                    </div>
                    <p className={styles.taskTitle}>{reward.name}</p>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      {/* Highlights */}
      <div className={styles.dailyTasksSection}>
        <div className={styles.dailyTasksHeader}>
          <div className={styles.dailyTasksTitleContainer}>
            <h3 className={styles.dailyTasksTitle}>{t('highlights')}</h3>
            <p className={styles.dailyTasksSubtitle}>{t('home_text_gen')}</p>
          </div>
          <button className={styles.viewAllButton} onClick={() => navigate('/highlights')}>
            {t('view_all')} <span>›</span>
          </button>
        </div>

        {loadingGameHighlights && <div className={styles.loading}>{t('loading')}</div>}
        {errorGameHighlights && <div className={styles.error}>{errorGameHighlights}</div>}
        {!loadingGameHighlights && !errorGameHighlights && (
          <Swiper
            breakpoints={breakpoints4Slides}
            className={styles.dailyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={gameHighlightsData.length > 4}
          >
            {gameHighlightsData.map((highlight) => {
              const gameImage = getGameHighlightImage(highlight.game);
              return (
                <SwiperSlide key={highlight.id}>
                  <div
                    className={styles.taskCard}
                    onClick={() => navigate(`/game-highlights?gameId=${highlight.gameId}&gameName=${highlight.game}`, '_blank')}
                    style={{ cursor: 'pointer' }}
                  >
                    <div
                      className={styles.taskImage}
                      style={{ backgroundImage: `url(${gameImage})` }}
                    >
                    </div>
                    <p className={styles.taskTitle}>{highlight.game}</p>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>
      
      <CannonClashInstructions
        isOpen={showInstructions}
        onClose={handleInstructionsClose}
      />
    </>
  );
}

export default Home;